import { Observable } from 'rxjs';
import { Product } from './model';

export interface ApiResponse<T = unknown> {
    data: T;
}

export abstract class ProductsRepository {
    abstract getAllProducts(
        uid: string,
        cid: string | null,
        query?: string,
        page?: number,
        limit?: number,
        onlyEnabled?: boolean,
        onlyNegativeStock?: boolean,
        hasTax?: boolean | null,
        stockStatus?: string | null,
        hasWarranty?: boolean | null,
        enable?: boolean | null
    ): Observable<ApiResponse<unknown>>;
    abstract uploadProductInventory(uid: string, cid: string | null, data: unknown): Observable<ApiResponse<unknown>>;
    abstract getProductById(uid: string, cid: string | null, sku: string): Observable<ApiResponse<unknown>>;
    abstract createProduct(uid: string, cid: string | null, data: Partial<Product>): Observable<ApiResponse<unknown>>;
    abstract editProduct(uid: string, cid: string | null, data: Partial<Product>, id: string | number): Observable<ApiResponse<unknown>>;
    abstract isEnable(uid: string, cid: string | null, id: string | number, is_enable: boolean): Observable<ApiResponse<unknown>>;
    abstract matchProducts(uid: string, cid: string | null, items: Array<{ sku?: string; description: string }>): Observable<ApiResponse<unknown>>;
    abstract deleteProduct(uid: string, cid: string | null, id: string | number): Observable<ApiResponse<unknown>>;
}
